<template>
  <div class="wrap reserve-wrap">
    <div class="top-header">
      <incBack></incBack>
      <h3>예약하기</h3>
    </div>
    <div class="body-wrap">
      <h4 v-if="isLoading == 0">
        받고 싶은 코칭 주제를 <br />
        선택해 주세요.
      </h4>
      <ul class="subject-wrap" v-if="isLoading == 0">
        <div class="question">
          <ul>
            <!-- @click="select(item,0)" class="clear" v-for="(item,index) in list[0].subList" :key="index" :class="{'active':item.isActive}" -->
            <li>
              <!-- <div class="float-left">
                                <span v-if="item.isActive"><b >{{item.order}}</b></span>
                            </div>
                            <p class="float-left">{{item.text}}</p> -->
              <select class="" v-model="parentCateIdx" @change="changeCategory()">
                <option value="0">대분류 선택</option>
                <option v-for="(item, index) in parentList" :key="index" :value="item.categoryIdx">
                  {{ item.categorySubject }}
                </option>
              </select>
            </li>
            <li>
              <select v-model="categoryIdx">
                <option value="0">소분류 선택</option>
                <option v-for="(item, index) in childList" :key="index" :value="item.categoryIdx">
                  {{ item.categorySubject }}
                </option>
              </select>
            </li>
            <!-- <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">리더십 – 동기부여 및 육성</p>
                        </li>
                        <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">자기관리/웰빙 - 시간관리</p>
                        </li>
                        <li @click="select()" class="clear">
                            <div class="float-left">
                                <span><b></b></span>
                            </div>
                            <p class="float-left">커뮤니케이션(소통) - 피드백</p>
                        </li> -->
          </ul>
        </div>
      </ul>
    </div>
    <div class="bnb-btn" v-if="isLoading != 1">
      <!-- 선택 시 class="active" 활성화 -->
      <button class="active" @click="next()">Next</button>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "reserve_subject_sub",
  data: () => ({
    isLoading: 0,
    list: [
      {
        subList: [
          {
            index: 0,
            value: 0,
            text: "리더십 - 목표설정",
            isActive: false,
            order: 0,
          },
        ],
      },
    ],
    selectData: [[]],
    originList: [],
    parentList: [],
    parentCateIdx: 0,
    childList: [],
    childCateIdx: 0,
    categoryIdx: 0,
    originCategory: [],
    originChildCategory: [],
  }),
  components: {
    incBack,
  },
  mounted() {
    this.getCategory();
    // this.getCourseInfo();
  },
  methods: {
    getCourseInfo() {
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
      };
      this.axios
        .get("/front/usercourseinfo", { params })
        .then((res) => {
          if (res.data.success) {
            this.parentList = [];
            let courseCate = res.data.data;
            for (let i = 0; i < courseCate.length; i++) {
              for (let j = 0; j < this.originCategory.length; j++) {
                if (courseCate[i].parentCategory == this.originCategory[j].categorySubject) {
                  this.parentList.push(this.originCategory[j]);
                }
                if (courseCate[i].childCategory == this.originCategory[j].categorySubject) {
                  this.originChildCategory.push(this.originCategory[j]);
                }
              }
            }

            this.parentList = this.parentList.reduce(function (acc, current) {
              if (acc.findIndex(({ categoryIdx }) => categoryIdx === current.categoryIdx) === -1) {
                acc.push(current);
              }
              return acc;
            }, []);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCategory() {
      this.childList = [];
      this.categoryIdx = "0";
      for (let item of this.originChildCategory) {
        if (item.categoryParent == this.parentCateIdx) {
          this.childList.push(item);
        }
      }
    },
    getCategory() {
      this.axios
        .get(`/front/embedded-survey-list`)
        .then((res) => {
          if (res.data.success) {
            this.originCategory = res.data.data;

            if (
              this.$store.state.courseInfo.courseCategoryLimit == "1" ||
              this.$store.state.courseInfo.courseCategoryLimit == "N"
            ) {
              if (this.$store.state.courseInfo.courseEmbeddedSurvey == "N") {
                this.originChildCategory = res.data.data;
                this.parentList = [];
                for (let item of this.originCategory) {
                  if (item.categoryParent == "0") {
                    this.parentList.push(item);
                  }
                }
              }
            } else {
              console.log(
                this.$store.state.courseInfo.courseCategoryLimit,
                "/front/embedded-survey-list API 실행 이후, N || 1 이면 getCourseInfo() 실행"
              );
              this.getCourseInfo();
            }
            // if(this.$store.state.courseInfo.courseCategoryLimit == '1' && this.$store.state.courseInfo.courseEmbeddedSurvey == 'Y'){

            // }else{
            //     this.getCourseInfo();
            // }

            // this.originList = res.data.data;

            // this.changeCategory();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    select(item, index) {
      if (!item.isActive) {
        this.selectData[index].push(item);
      } else {
        let find_idx = this.selectData[index].findIndex((obj) => obj.value == item.value);
        this.selectData[index].splice(find_idx, 1);
      }
      console.log(this.selectData[index]);
      for (let i = 0; i < this.list[index].subList.length; i++) {
        if (this.selectData[index].length > 0) {
          for (let j = 0; j < this.selectData[index].length; j++) {
            if (this.list[index].subList[i].value == this.selectData[index][j].value) {
              this.list[index].subList[i].isActive = true;
              this.list[index].subList[i].order = j + 1;
              break;
            } else {
              this.list[index].subList[i].isActive = false;
              this.list[index].subList[i].order = 0;
            }
          }
        } else {
          this.list[index].subList[i].isActive = false;
          this.list[index].subList[i].order = 0;
        }
      }
    },
    next() {
      if (this.categoryIdx == 0) {
        alert("받고 싶은 코칭 주제를 선택해 주세요.");
        return false;
      } else {
        let params = {
          categoryIdxList: [],
          userIdx: this.$store.state.userInfo.userIdx,
          courseIdx: this.$store.state.courseInfo.courseIdx,
        };
        params.categoryIdxList.push(Number(this.categoryIdx));
        this.axios
          .post("/front/user/embedded-survey-insert", params)
          .then((res) => {
            if (res.data.success) {
              this.$store.commit("setpageFunc", "0");
              this.$router.push({ name: "start_coach_recom", params: { rebook: 0 } });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>
